import { mergeWith } from 'lodash';
import saveAs from 'file-saver';
import QuickFetch from 'quickfetch';
import { init } from '../ConfigHelper';
import useHeadersMiddleware from './middlewares/headers';
import useTimeoutMiddleware from './middlewares/timeout';
import useBadHTTPMiddleware from './middlewares/badHTTP';
import useWrongBusiMiddleware from './middlewares/wrongBusiness';

/**
 * 用于配置请求基本信息的常量
 */
const DEFAULT_URL = '/api/cps';
const { SERVER_URL } = init(null);
const TIMEOUT = 30000;

const Wrapper = function(option) {
  const r = new QuickFetch(mergeWith({
    timeout: TIMEOUT,
    baseURL: SERVER_URL,
    ignoreBodyMethods: ['get', 'head', 'delete']
  }, option));

  useHeadersMiddleware(r);
  useTimeoutMiddleware(r);
  useBadHTTPMiddleware(r);
  const wrongBusiMiddleware = useWrongBusiMiddleware(r);

  // extend a download method
  r.download = function(method, url, params, roption) {
    const dlFetchId = 'my_download';

    wrongBusiMiddleware.pause(dlFetchId);

    const downHeadersMiddleware = r.use(QuickFetch.REQUEST, (req, next) => {
      req.headers.set('Content-Type', 'application/x-www-form-urlencoded');
      next(req);
    }, dlFetchId);

    return QuickFetch.prototype[method.toLowerCase()]
      .call(r, url, params, mergeWith(roption, {
        fetchId: dlFetchId,
        catchError: false
      }))
      .then(
        (res) => {
          const disposition = res.headers.get('content-disposition');
          if (disposition && disposition.match(/attachment/)) {
            let filename = disposition.replace(/attachment;.*filename=/, '').replace(/"/g, '');
            filename = filename && filename !== ''
              ? filename
              : 'download';
            res.blob().then(blob => saveAs(blob, filename));
          }
          return res.json();
        }
      )
      .finally(
        () => {
          downHeadersMiddleware.unuse();
          wrongBusiMiddleware.resume(dlFetchId);
        }
      );
  };

  ['get', 'post', 'delete', 'put', 'patch'].forEach((method) => {
    const originFunc = r[method];
    r[method] = function(...args) {
      // 兼容之前封装 vue-resource 时的写法 🐶
      if (args.length === 1 && typeof args[0] === 'object') {
        const {
          url, action, serverUrl, param, body, success, fail, error, timeout, ...others
        } = args.shift();

        if (error) {
          throw new Error('the "error" callback is deprecated! use "fail" to replace it.');
        }

        const reqURL = `${url || DEFAULT_URL}/${action}`.replace(/\/+/g, '/');
        const reqParams = mergeWith(null, param, body);
        const reqInit = {
          baseURL: serverUrl || SERVER_URL,
          timeout: timeout || TIMEOUT,
          catchError: false, // typeof fail === 'function',
          ...others
        };

        return originFunc.call(r, reqURL, reqParams, reqInit)
          .then(async (res) => {
            if (res instanceof Error) throw res;
            if (typeof success === 'function') {
              const { data } = await res.clone().json();
              success.call(null, data);
            }
            return res;
          })
          .catch((err) => {
            if (typeof fail === 'function') {
              const { data } = err.data;
              fail.call(null, data);
              return;
            }
            throw err;
          });
      }

      r._args = args;

      // 正常写法
      return originFunc.apply(r, args)
        .then(async (res) => {
          if (res instanceof Error) {
            return Promise.reject(res);
          }
          const resJson = await res.json();
          return resJson;
        });
    };
  }); // end of http methods

  return r;
};

const wrapper = new Wrapper();
export default wrapper;

// 兼容 \build\globals.js 的全局引用方式 🐶
export const get = wrapper.get.bind(wrapper);
export const post = wrapper.post.bind(wrapper);
export const del = wrapper.delete.bind(wrapper);
export const put = wrapper.put.bind(wrapper);
export const patch = wrapper.patch.bind(wrapper);
export const download = wrapper.download.bind(wrapper);



// WEBPACK FOOTER //
// ./src/common/fetchWrapper/index.js